export default __webpack_public_path__ + "static/media/validateOTP.ef77afdf.png";